import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Filters} from '../../../components/common/filters';
import {fetchListings} from '../../../actions/listings';
import {pushEdapEvent, getRefinements} from '../../../utils/edap';
import {UNREFINED_KEY} from '../../../utils/listings';
import {TESTS} from '../../../utils/abacus';
import MvtTest from '../../../components/common/mvt/MvtTest/MvtTest';
import FilterPill from '../../../components/common/filters-pill';

/* original design */

export function sendToEdap(refinementKey, position) {
    const mainData = {
        actionlocation: 'properties-module',
        eventrefinements: getRefinements({
            refinementKey,
            position,
            forceAddRefinementKey: true,
        }),
    };
    pushEdapEvent('refinement.click', mainData);
}

function getButtonClasses(isActive) {
    return `btn btn-sm ${isActive ? 'btn-primary' : 'btn-default'}`;
}

export class SegmentFiltersOriginal extends Component {
    static getDerivedStateFromProps(props, state) {
        const {overrideActive, filterOverride} = props;

        const {activeFilter} = state;

        if (overrideActive && filterOverride !== activeFilter) {
            return {
                activeFilter: filterOverride,
            };
        }

        return null;
    }

    constructor(props) {
        super(props);

        this.clickHandler = this.clickHandler.bind(this);

        this.state = {
            activeFilter: UNREFINED_KEY,
        };
    }

    clickHandler(segmentKey, position) {
        if (this.state.activeFilter === segmentKey) {
            return;
        }

        this.props.fetchListings(segmentKey);

        this.setState({
            activeFilter: segmentKey,
        });

        sendToEdap(segmentKey, position);
    }

    render() {
        const {activeFilter} = this.state;

        const {segments, segmentFilters} = this.props;

        if (!segments) {
            return null;
        }

        return (
            <Filters>
                {segments.map((segment, index) => (
                    <button
                        key={segment.messageKey}
                        className={getButtonClasses(
                            activeFilter === segment.messageKey
                        )}
                        onClick={this.clickHandler.bind(
                            null,
                            segment.messageKey,
                            index + 1
                        )} //eslint-disable-line
                    >
                        {segmentFilters[`${segment.messageKey}`]}
                    </button>
                ))}
            </Filters>
        );
    }
}

/* new pill design */

export function SegmentFiltersRedesign(props) {
    const initialFilter = props.overrideActive
        ? props.filterOverride
        : UNREFINED_KEY;

    const {segments, segmentFilters} = props;

    if (!segments || segments.length === 0) {
        return null;
    }

    const filters = segments.map((segment) => ({
        label: segmentFilters[`${segment.messageKey}`],
        id: segment.messageKey,
    }));

    return (
        <FilterPill
            initialFilter={initialFilter}
            filters={filters}
            onSelection={props.fetchListings}
            actionlocation={'properties-module'}
        />
    );
}

/* connected */

const MIN_SEGMENTS = 1;

const UNREFINED_SEGMENT = {
    name: 'Popular',
    messageKey: UNREFINED_KEY,
};

function transformSegments(segments = []) {
    return segments.length > MIN_SEGMENTS
        ? [UNREFINED_SEGMENT, ...segments]
        : null;
}

function SegmentFiltersWrapper(props) {
    const SegmentFilters = props.usePillFilters
        ? SegmentFiltersRedesign
        : SegmentFiltersOriginal;

    return (
        <MvtTest test={TESTS.PILL_FILTER_DESIGN}>
            <div>
                <SegmentFilters {...props} />
            </div>
        </MvtTest>
    );
}

export const mapStateToProps = (state) => ({
    segments: transformSegments(state.destination.segments),
    segmentFilters: state.modules.segmentFilters,
    usePillFilters: state.options.usePillFilters,
});

function mapDispatchToProps(dispatch) {
    return {
        fetchListings: (key) => dispatch(fetchListings({segmentKey: key})),
    };
}

export const SegmentFilters = connect(
    mapStateToProps,
    mapDispatchToProps
)(SegmentFiltersWrapper);

SegmentFilters.displayName = 'SegmentFilters';

export default SegmentFilters;
